import React, { useState } from "react";
import "../SignIn/SignIn.css";
import "../ForgotPassword/ForgotPassword.css";
import "../OTP/OTP.css";
import { Image, Container, Col, Row, Button } from "react-bootstrap";
import Logo from "../../assets/communityXlogo.svg";
import { Link, useNavigate } from "react-router-dom";
import forgot from "../../assets/forgot.png";
import OTPInput, { ResendOTP } from "otp-input-react";
import { MdArrowBack } from "react-icons/md";
import { useLocation } from "react-router-dom";
import { OtpCheck } from "../../ConditionChecks/ConditionChecks";
import ErrorLabel from "../../Components/ErrorLabel/ErrorLabel";
import { ForgotPswdValidateOtp } from "../../Utils/Api/ForgotPswdValidateOtp";
import Loader from "../../Components/Loader/Loader";
import { toast } from "react-toastify";
import { ServerError } from "../../Utils/GlobalVariables/ToastifierVariables";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { Forgotpassword } from "../../Utils/Api/Forgotpassword";

const OTP = () => {
  // Redux data 1
  const Reduxdata = useSelector((state) => state);

  const timeperiod = Reduxdata.OTPCounter.OTPCounterTime * 60;

  const [Otp, setOtp] = useState("");
  const [errDisplay, setErrDisplay] = useState("");
  const [loading, setLoading] = useState(false);
  const [flag, setFlag] = useState(false);
  const [otpRes, setOtpRes] = useState({});

  // time counter
  const [timer, setTimer] = useState(timeperiod);

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;

    return `${minutes.toString().padStart(2, "0")}:${seconds
      .toString()
      .padStart(2, "0")}`;
  };

  const location = useLocation();
  const OtpApiData = location?.state?.data ? location?.state?.data : {};

  const onOtp = () => {
    setErrDisplay("");
  };

  // console.log(OtpApiData)
  // console.log(Otp)

  const navigate = useNavigate();

  const SubmitHandler = (e) => {
    e.preventDefault();
    // console.log(Otp)
    const OtpValidation = OtpCheck(Otp);

    if (OtpValidation.input === "empty") {
      setErrDisplay(OtpValidation.err_display);
    }
    if (OtpValidation.input === "LessCharacters") {
      setErrDisplay(OtpValidation.err_display);
    }
    if (OtpValidation.validition === true) {
      let validateOtp = {
        uid: flag === true ? otpRes.uid : OtpApiData?.uid,
        token: flag === true ? otpRes.token : OtpApiData?.token,
        otp: parseInt(Otp.trim()),
      };
      ForgotPasswordApiHandler(validateOtp);
    }
    // if (OtpValidation.validition === true) {
    //   let validateOtp = {
    //     uid: OtpApiData.uid,
    //     token: OtpApiData.token,
    //     otp: parseInt(Otp.trim()),
    //   };
    //   console.log(validateOtp);
    //   ForgotPasswordApiHandler(validateOtp);
    // }
  };

  const ForgotPasswordApiHandler = async (validateOtp) => {
    setLoading(true);
    const ForgotPswdApiResponse = await ForgotPswdValidateOtp(
      validateOtp,
      () => {
        navigate("/");
      }
    );
    if (ForgotPswdApiResponse === false) {
      toast.error(ServerError, {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      navigate("/forgotpassword");
      setLoading(false);
    } else {
      if (ForgotPswdApiResponse.success === true) {
        toast.success(ForgotPswdApiResponse.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setOtp("");
        navigate("/createnewpassword", {
          state: { token: ForgotPswdApiResponse.token },
        });
        setLoading(false);
      } else {
        toast.error(ForgotPswdApiResponse.message, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  const ResendCode = Reduxdata.PersistedData.ResendCode.ResendCode;

  const ResendCodeHandler = async () => {
    setFlag(true);
    setLoading(true);
    const ResendCodeRes = await Forgotpassword(ResendCode, () => {
      navigate("/");
    });
    if (ResendCodeRes === false) {
      toast.error("Internal Server Error!", {
        position: "top-center",
        width: "500px",
        autoClose: 6000,
        hideProgressBar: true,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "dark",
      });
      setLoading(false);
    } else {
      if (ResendCodeRes.success === true) {
        toast.success(ResendCodeRes.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setErrDisplay("");
        setTimer(ResendCodeRes.timer * 60);
        setOtpRes(ResendCodeRes);
        setLoading(false);
      } else {
        toast.error(ResendCodeRes.p_responseMessage, {
          position: "top-center",
          width: "500px",
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "dark",
        });
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    let intervalId = null;

    if (timer > 0) {
      intervalId = setInterval(() => {
        setTimer((prevTimer) => prevTimer - 1);
      }, 1000);
    }

    return () => {
      clearInterval(intervalId);
    };
  }, [timer]);

  useEffect(() => {
    setTimer(timeperiod);
  }, [timeperiod]);

  return (
    <>
      {loading ? <Loader /> : ""}
      <div className="main">
        <Container>
          <Row className="justify-content-md-center py-3 mobile-main">
            <Col md="6" className="page-content-left text-center hide-mobile">
              <Image
                loading="lazy"
                src={forgot}
                className="my-5 py-5 imgwidth-100"
              ></Image>
            </Col>
            <Col md="6" className="page-content-right">
              <div className="text-center mb-2 mt-5">
                <Image loading="lazy" src={Logo} className="logo_Image"></Image>
                <p className="sign-second pt-5 pb-2">Forgot Password</p>
              </div>
              <Row>
                <div className="signemail mt-3 pt-0 pb-3 text-center">
                  {ResendCode?.check === 2 ? (
                    <p className="text-center recive-text">
                      Please enter the one-time verification code sent to your
                      registered mobile number
                    </p>
                  ) : (
                    <>
                      <p className="text-center recive-text">
                        Please enter the one-time verification code sent to your
                        registered email
                      </p>
                      <p
                        className="text-center recive-text"
                        style={{ fontStyle: "italic" }}
                      >
                        (If you haven't received the One-time verification code
                        in your inbox, we kindly request you to check your spam
                        folder.)
                      </p>
                    </>
                  )}

                  <OTPInput
                    className="otp-section mt-4 mb-2"
                    value={Otp}
                    onChange={(val) => {
                      setOtp(val);
                      onOtp();
                    }}
                    autoFocus
                    OTPLength={6}
                    otpType="number"
                    disabled={false}
                    maxTime={-1}
                  />
                  <div className="p-2">
                    {errDisplay ? (
                      <ErrorLabel ErrorDisplay={errDisplay} />
                    ) : timer !== 0 ? (
                      <p style={{ color: "#e66100" }}>
                        The One-time verification code sent will expire in{" "}
                        {formatTime(timer)} minutes
                      </p>
                    ) : (
                      <></>
                    )}
                    {/* <ErrorLabel
                      ErrorDisplay={errDisplay}
                      color={errDisplay === "Successful!" ? true : false}
                    /> */}
                  </div>
                  <Link
                    onClick={ResendCodeHandler}
                    className="resendotp-section"
                  >
                    <p className="forgot-text">Resend Code</p>
                  </Link>
                  <Button
                    variant="primary"
                    onClick={SubmitHandler}
                    className="green-btn mt-2 mb-3 otp-submit"
                  >
                    Verify
                  </Button>
                </div>
                <Link to={"/forgotpassword"}>
                  <p className="text-center back-btn">
                    <MdArrowBack />
                    Back
                  </p>
                </Link>
                <p
                  style={{
                    textAlign: "center",
                    paddingTop: "50px",
                    color: "white",
                  }}
                >
                  (Do not refresh the page!)
                </p>
              </Row>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};

export default OTP;
